// extracted by mini-css-extract-plugin
export default {"dataElements":"data-elements_dataElements__fKrxu","buttonBar":"data-elements_buttonBar__uKjDl","heading":"data-elements_heading__ZLMEx","content":"data-elements_content__UagXQ"};